module.exports = __webpack_public_path__ + "img/first-0.458d8793.webp";